/// <reference types="./states.d.mts" />
import * as $project from "../../../../../common/data/project.mjs";
import * as $proposal from "../../../../../common/data/proposal.mjs";
import * as $l from "../../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../../ds/ds/components/skeleton.mjs";
import * as $list from "../../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../../lustre/lustre/element/html.mjs";
import * as $length from "../../../../../sketch/sketch/css/length.mjs";
import * as $model from "../../../../data/model.mjs";
import * as $msg from "../../../../data/msg.mjs";
import * as $common from "../../../../frontend/view/projects/show/common.mjs";
import * as $s from "../../../../frontend/view/styles/proposals.mjs";
import { toList } from "../../../../gleam.mjs";

export function no_questions_placeholder() {
  return $s.no_questions_wrapper(
    toList([]),
    toList([
      $s.empty_sheet(
        toList([]),
        toList([$el.text("This sheet does not contain any questions.")]),
      ),
      $s.empty_sheet(
        toList([]),
        toList([$el.text("However it will be kept as-is during the export.")]),
      ),
    ]),
  );
}

function no_questions_found() {
  return $s.no_questions_wrapper(
    toList([]),
    toList([
      $s.empty_sheet(
        toList([]),
        toList([
          $el.text(
            "This proposal has been deleted, please go back to the proposals home page.",
          ),
        ]),
      ),
    ]),
  );
}

export function not_found(_) {
  return $l.fragment(
    toList([
      $l.column(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $common.proposal_back(),
          $l.row(
            toList([$l.gap(8), $l.justify("space-between")]),
            toList([]),
            toList([$h.div(toList([$a.style("height", "25px")]), toList([]))]),
          ),
        ]),
      ),
      $s.questions_wrapper(toList([]), toList([no_questions_found()])),
    ]),
  );
}

export function question_body_skeleton() {
  return $l.column(
    toList([$l.gap(4)]),
    toList([]),
    toList([
      $skeleton.custom($length.percent(100), $length.px(10)),
      $skeleton.custom($length.percent(90), $length.px(10)),
      $skeleton.custom($length.percent(100), $length.px(10)),
      $skeleton.custom($length.percent(80), $length.px(10)),
      $skeleton.custom($length.percent(20), $length.px(10)),
    ]),
  );
}

function loading_question() {
  return $s.question_card(
    9000,
    toList([]),
    toList([
      $s.question_card_header(
        toList([]),
        toList([
          $skeleton.skeleton(30, 30),
          $s.question_number(toList([]), toList([$skeleton.skeleton(80, 30)])),
          $s.question_status(toList([]), toList([$skeleton.skeleton(80, 30)])),
          $s.question_question_skeleton(toList([$skeleton.skeleton(200, 30)])),
          $s.question_owner(
            toList([]),
            toList([
              $skeleton.skeleton(150, 30),
              $skeleton.skeleton(150, 30),
              $skeleton.skeleton(30, 30),
            ]),
          ),
        ]),
      ),
      question_body_skeleton(),
      $s.question_sources(
        toList([]),
        toList([$skeleton.skeleton(150, 20), $skeleton.skeleton(80, 20)]),
      ),
    ]),
  );
}

function loading_questions() {
  return $s.questions_wrapper(
    toList([]),
    toList([
      $s.question_questions(
        toList([]),
        (() => {
          let _pipe = $list.map(
            $list.range(0, 5),
            (_) => { return loading_question(); },
          );
          return $list.intersperse(_pipe, $s.separator());
        })(),
      ),
      $s.question_spreadsheet_sheets(
        toList([]),
        toList([$skeleton.skeleton(200, 25)]),
      ),
    ]),
  );
}

export function proposal_loading(_) {
  return $l.fragment(
    toList([
      $l.column(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $common.proposal_back(),
          $l.row(
            toList([$l.gap(8), $l.justify("space-between")]),
            toList([]),
            toList([
              $l.row(
                toList([$l.align("center"), $l.gap(8)]),
                toList([]),
                toList([$skeleton.skeleton(20, 20), $skeleton.skeleton(200, 45)]),
              ),
              $skeleton.skeleton(120, 45),
            ]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $l.row(
            toList([$l.justify("space-between")]),
            toList([]),
            toList([$skeleton.skeleton(100, 40), $skeleton.skeleton(150, 40)]),
          ),
          loading_questions(),
        ]),
      ),
    ]),
  );
}

export function proposal_questions_loading(model, project, proposal) {
  return $l.fragment(
    toList([
      $l.column(
        toList([$l.gap(8)]),
        toList([]),
        toList([
          $common.proposal_back(),
          $l.row(
            toList([$l.gap(8), $l.justify("space-between")]),
            toList([]),
            toList([$common.proposal_title(model, project, proposal, false)]),
          ),
        ]),
      ),
      $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $l.row(
            toList([$l.justify("space-between")]),
            toList([]),
            toList([$skeleton.skeleton(100, 40), $skeleton.skeleton(150, 40)]),
          ),
          loading_questions(),
        ]),
      ),
    ]),
  );
}
